<template>
  <div class="home">
    <banner-Component></banner-Component>
  <div class="main">
<!--    应用领域-->
    <div class="one wow fadeInUp">
   <p class="title">
     {{$t('home').text3}}
     <span>{{$t('home').text4}}</span>
   </p>
    </div>
    <div class="yList wow fadeInUp">
      <div class="item" v-for="(item,index) in yList" :key="index">
        <img :src="item.img" alt="">
        <p class="name">{{item.name}}</p>
        <p class="zy">{{item.con}}</p>
        <p class="more">{{$t('btn')}}
        <i class="iconfont icon-xiangzuoyuanjiantouzuojiantouxiangzuoxianxing"></i></p>
      </div>
    </div>

<!--    获取更多信息-->
  <div class="info wow fadeInUp">
    <img class="bigImg" src="../assets/azf/info.png" alt="">
    <div class="textInfo">
     <p>{{$t('home').text5}}</p>
      <p>{{$t('home').text6}}</p>
      <div class="items">
         <div class="item" v-for="(item,index) in iList" :key="index">
           <img :src="item.img" alt="">
           <p>{{item.name}}</p>
         </div>
      </div>
    </div>
      <div class="btn" @click="goto(4)">
          <p>{{$t('btn1')}}</p>
      </div>
  </div>

<!--      关于-->
<div class="about wow fadeInUp">
<div class="left">
    <img src="../assets/azf/ab.png" alt="">
</div>
    <div class="right">
        <div class="o">
            <p class="title">
                {{$t('home').text7}}
                <span>{{$t('home').text8}}</span>
            </p>
        </div>
        <p class="intro">{{$t('about').text0}}</p>
        <p class="more" @click="goto(0)">{{$t('btn')}}
            <i class="iconfont icon-xiangzuoyuanjiantouzuojiantouxiangzuoxianxing"></i></p>
        <div class="allItem">
          <div class="item" v-for="(item,index) in aList" :key="index">
              <div class="i">
                  <img :src="item.img" alt="">
              </div>
              <p>{{item.name}}</p>
          </div>
        </div>
    </div>
</div>

      <!--    帮助支持-->
      <div class="one wow fadeInUp">
          <p class="title">
              {{$t('home').text10}}
          </p>
      </div>
      <div class="nList wow fadeInUp">
          <div class="item" v-for="(item,index) in nList" :key="index" @click="goto(index+1)">
              <img :src="item.img" alt="">
              <p class="name">{{item.name}}</p>
              <p class="zy">{{item.con}}</p>
              <p class="more" >{{$t('btn')}}
                  <i class="iconfont icon-xiangzuoyuanjiantouzuojiantouxiangzuoxianxing"></i></p>
          </div>
      </div>

  </div>

      <foot-Component></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import btnComponent from '../components/btn'
  import Scrollbar from 'smooth-scrollbar'
  import footComponent from '../components/foot'
  import '../common/jquery-1.11.3.min'
export default {
  name: 'homea',
    data(){
      return{
          aList:[
              {
                  img:require('../assets/azf/pz.png'),
                  name:'高品质产品'
              },
              {
                  img:require('../assets/azf/jg.png'),
                  name:'有优势价格定位'
              },
              {
                  img:require('../assets/azf/xt.png'),
                  name:'快速的供货系统'
              },  {
                  img:require('../assets/azf/td.png'),
                  name:'高素质服务团队'
              }
          ],
          enaList:[
              {
                  img:require('../assets/azf/pz.png'),
                  name:'High quality products'
              },
              {
                  img:require('../assets/azf/jg.png'),
                  name:'Competitive pricing'
              },
              {
                  img:require('../assets/azf/xt.png'),
                  name:'Fast supply system'
              },  {
                  img:require('../assets/azf/td.png'),
                  name:'High quality service team'
              }
          ],
        iList:[
          {
            img:require('../assets/azf/yj.png'),
              name:'愿景'
          },
            {
                img:require('../assets/azf/sm.png'),
                name:'使命'
            },
            {
                img:require('../assets/azf/jz.png'),
                name:'价值'
            }
        ],
          eniList:[
              {
                  img:require('../assets/azf/yj.png'),
                  name:'Vision'
              },
              {
                  img:require('../assets/azf/sm.png'),
                  name:'Mission'
              },
              {
                  img:require('../assets/azf/jz.png'),
                  name:'Value'
              }
          ],
        yList:[
          {img:require('../assets/azf/jc.png'),name:'汽车工业',con:'EDSV遵循IATF16949的相關質量體系執行。我们的产品在汽车运用有着高質素的品质、卓越的技巧和强大的创新能力。拥有全进口的橡胶材料(FKM、FFKM、FVMQ、EPDM、 SILICONE、HNBR、CR、NBR、ACM、AEM)及全进口的制成设备和質控設備。无论是传统的汽车还是新能源汽车都得于广泛运用，如转向、制动、发动机、控制系统和电机。现同众多的整车厂进行合作，同时也是二级和三级汽车配件品牌首选密封件供应商。'},
          {img:require('../assets/azf/ny.png'),name:'能源化工',con:'能源化工领域是EDSV壹直创新根深的。工业的不断进步，客户设备也被更广泛的运用到各场合，那封密封的性能提到新的高度。除去常规了解的EPDM和FKM的耐化学性，EDSV有更多特种橡胶供客户选用。如:FVMQ、 AFLAS、FFKM以及PTFE复合材料的制成品都有着极强的耐介质性和温度大跨度性(-200-300℃)就不同材质选择。'},
          {img:require('../assets/azf/gc.png'),name:'工程机械',con:'工业的不断进步，客户设备也被广泛的运用到各场合，那样密封的性能提到新的高度...'},
          {img:require('../assets/azf/bdt.png'),name:'低温运用',con:'随着客户下游的不断延伸，我们一直在这个过程中扮演着先行者。EDSV在多年前就开发了用于低温领域的橡胶材料，从常规的低温性-40℃到TR10-53℃,解决客户设备在低温环境工作时的泄露问题。同时，针对低温介质密封问题，拥有PTFE材料改良技术，可应用于-200°℃。我们的前瞻能力、优秀的国际资源整合能力为客户的产品运用提供极有力的保障。'}
        ],
          enyList:[
              {img:require('../assets/azf/jc.png'),name:'Automotive Industry',con:'EDSV adheres to and strictly implements the quality system of IATF16949.\n' +
                      'We are proven to be with high quality,outstanding technology and strong creativity in the\n' +
                      'automotive industry.All the rubber Including FKM、FFKM、FVMQ、EPDM、\n' +
                      'SILICONE、HNBR、CR、NBR、ACM、AEM,ctc.and the facilities of production&\n' +
                      'quality control are imported from overseas.No matter in traditional automotive or electric\n' +
                      'vehicles applications,our products are widely used,such as steering system,braking system,\n' +
                      'cooling system,controlling system,engines,gearboxes and motors,Currently,EDSV has\n' +
                      'been in cooperation with many vehicles manufacturers and also supply to sub-tier or\n' +
                      'tier-three automotive parts brands.\n'},
              {img:require('../assets/azf/ny.png'),name:'Energy and Chemical Industry',con:'EDSV is very experienced in Energy & Chemical Engineering industry and keeps innovating.\n' +
                      'With the constant developing of the industry,the cquipment of our customers are employed in\n' +
                      'more and more applications which requires better performance of the sealing parts.\n' +
                      'Apart frorm the standard compounds EPDM and FKM with good chemical resistance,EDSV\n' +
                      'has more special compounds with excellent chemical resistance and wide temperature range\n' +
                      '(-200 to 300℃)available such as FVMQ,AFLAS,FFKM and PTFE composite.\n'},
              {img:require('../assets/azf/gc.png'),name:'Construction machinery',con:'The continuous improvement of the industry, the customer equipment is also widely used in various occasions, so the performance of the seal refers to the new height...'},
              {img:require('../assets/azf/bdt.png'),name:'Low temperature Applications',con:'With continuous extending of ourcustomers in-depth exploitation,EDSV has been the\n' +
                      'pioneer of the innovative sealing solutions.\n' +
                      'EDSV has developed rubbermaterials specially forlow temperature applications,ranging\n' +
                      'from compounds with standard low temperature brittleness of-40Cto TR10 values-53℃\n' +
                      'to fix the leakage of customers\'equipment in low temperature working conditions.\n' +
                      'Meanwhile,for the challenging sealing ofchemical medium in ultra-low temperature\n' +
                      'conditions,we have the most advanced technology to improve PTFE material which willbe\n' +
                      'applicable forlow temperature up to-200℃.\n' +
                      'Our foresightand outstanding ability to integrate international resources provide effective\n' +
                      'guarantee forourcustomers\'applications.\n'}
          ],
          nList:[
              {img:require('../assets/azf/n1.png'),name:'新闻资讯',con:'关注 EDSV 最新实时动态，第一时间了解业内新鲜事及 EDSV 最新展会活动预告...'},
              {img:require('../assets/azf/yb.png'),name:'获取最新版EDSV样本',con:'请访问EDSV的下载中心，获取最新版密封件样本'},
              {img:require('../assets/azf/pp.png'),name:'定制开发',con:'技术不断在革新，需求也不断的创新，爱之福为您提供全方位定制化服务，以满足您的特定需求'}
          ],
          ennList:[
              {img:require('../assets/azf/n1.png'),name:'News',con:'Pay attention to the latest real-time dynamics of EDSV, and be the first to know about the latest events in the industry and the latest EDSV event announcements...'},
              {img:require('../assets/azf/yb.png'),name:'Get the latest version of EDSV products catalog',con:'Visit the EDSV Download Center for the latest seal sample'},
              {img:require('../assets/azf/pp.png'),name:'Customized products',con:'Technology is constantly innovating, and demand is constantly innovating.EDSV provides you with a full range of customized services to meet your specific needs.'}
          ]
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        if(this.$i18n.locale==='en'){
            this.yList=this.enyList
            this.iList=this.eniList
            this.nList=this.ennList
            this.aList=this.enaList
        }
        localStorage.setItem('index','0')
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener(() => {
            $(".main div").each(function() {
                var _this = $(this);
                if ($(window).scrollTop() >= $(this).offset().top - $(window).height() + 50)
                {
                    _this.addClass('show');
                }else{
                    _this.removeClass('show');
                }
            });
            window.pageYOffset=this.scrollbar.scrollTop
        });
    },
  components:{bannerComponent,btnComponent,footComponent},
    methods:{
        gotoPro(){
            const link = `/pro.html`
            window.open(link,'_self')
        },
      goto(n){
          const link = `/about.html?nid=${0}`
          const nlink = `/faq.html`
          const dlink = `/tele.html?nid=${n}`
          const alink = `/about.html?nid=${1}`
          if(n===0){
              window.open(link,'_self')
          }else if(n===1){
              window.open(nlink,'_self')
          }else if(n===2 || n===3){
              window.open(dlink,'_self')
          }else if(n===4){
              window.open(alink,'_self')
          }
      },
    }
}
</script>

<style lang="scss" scoped>
.home{
  width:100%;
  overflow: hidden;
    transform: translateY(50px);
    animation: run 3s linear forwards;
    @keyframes run {
        from{
            transform: translateY(50px);
        }
        to{
            transform: translateY(0);
        }
    }
  .main{
    width:100%;
    padding-bottom: 60px;
    .one{
      width:100%;
      padding-top: 40px;
      border-bottom: 1px solid #ECECEC;
      .title{
        width:1440px;
        margin: 0 auto;
        font-family: "Microsoft YaHei";
        font-weight: bolder;
        font-size: 25px;
        position: relative;
        padding-bottom: 20px;
        span{
          font-size: 14px;
          color:#9F9F9F;
         font-family: "Fira Code Medium";
          font-weight: lighter;
          padding-left: 10px;
        }
      }
      .title::after{
        content:'';
        display: inline-block;
        position: absolute;
        left:0;
        width:100px;
        height:1px;
        bottom:0;
        background-color: #0071BD;
      }

    }
    .yList{
      width:1440px;
      margin: 60px auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .item{
        width:24%;
        cursor: pointer;
        overflow: hidden;
        img{
          width:100%;
          object-fit: cover;
          transition: all 1s;
        }
        .name{
          padding: 20px 0;
          color:#383838;
          font-size: 22px;
          font-family: "Microsoft YaHei";
          font-weight: bolder;
          transition: all 1s;
        }
        .zy{
          color:#979797;
          font-size: 14px;
          line-height: 30px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          transition: all 1s;
          font-family: "Microsoft YaHei UI Light";
        }
        .more{
          color:#979797;
          font-size: 14px;
          font-family: "Microsoft YaHei UI Light";
          padding-top: 20px;
          transition: all 1s;
          i{
            padding-left: 10px;
          }
        }
      }
      .item:hover{
        img{
          transform: scale(1.05);
        }
        .zy{
          color:black;
        }
        .more{
          color:#005FAC;
        }
      }
    }
    .info{
      width:100%;
        position: relative;
        overflow: hidden;
        .bigImg{
        width:100%;
        object-fit: cover;
      }
        .textInfo{
            position: absolute;
            left:0;
            top:120px;
            width:100%;
            text-align: center;
            p:nth-child(1){
                font-family: "Microsoft YaHei";
                font-weight: bolder;
                font-size: 25px;
                color:white;
            }
            p:nth-child(2){
                font-family: "Fira Code Medium";
                font-weight: lighter;
                font-size: 14px;
                color:white;
                padding: 30px 0;
            }
            .items{
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin-top: 30px;
                .item{
               padding: 0 50px;
                    cursor: pointer;
                    img{
                        transition: all 1s;
                    }
                    p{
                        transition: all 1s;
                    }
                }
                .item:hover{
                    img{
                        transform: rotateY(180deg);
                    }
                    p{
                        color:#67B233;
                    }
                }
            }
        }
        .btn{
            padding: 0 15px;
            position: absolute;
            right:22%;
            bottom:22%;
            width:100px;
            height:30px;
            cursor: pointer;
            border-bottom: 1px solid rgba(255,255,255,.3);
            overflow: hidden;
            transition: all 1s;
            p{
                position: absolute;
                left:0;
                top:0;
                font-family: "Microsoft YaHei UI Light";
                font-size: 14px;
                color:white;
                z-index: 100;
                width:100%;
                text-align: center;
                height:100%;
                line-height: 30px;
            }
        }
        .btn::after{
            content:'';
            display: inline-block;
            height:30px;
            width:100%;
            background-color: #67B233;
            left:0;
            bottom:-30px;
            position: absolute;
            transition: all 1s;
        }
        .btn:hover{
           border-color:transparent;
        }
        .btn:hover::after{
            bottom:0;
        }
    }
      .about{
          width:1440px;
          margin: 60px auto;
          display: flex;
          flex-direction: row;
          padding-bottom: 120px;
          .left{
              width:35%;
              cursor: pointer;
              padding: 20px 20px;
              border: 1px solid #E3E3E3;
              img{
                  width:100%;
                  object-fit: cover;
                  transition: all 1s;
              }
          }
          .left:hover{
              img{
                  transform: scale(1.05);
              }
          }
          .right{
              width:58%;
              margin-left: 7%;
              .o{
                  width:100%;
                  border-bottom: 1px solid #D0D0D0;
                  .title{
                      width:100%;
                      margin: 0 auto;
                      font-family: "Microsoft YaHei";
                      font-weight: bolder;
                      font-size: 25px;
                      position: relative;
                      padding-bottom: 20px;
                      span{
                          font-size: 14px;
                          color:#9F9F9F;
                          font-family: "Fira Code Medium";
                          font-weight: lighter;
                          padding-left: 10px;
                      }
                  }
                  .title::after{
                      content:'';
                      display: inline-block;
                      position: absolute;
                      left:0;
                      width:100px;
                      height:1px;
                      bottom:0;
                      background-color: #0071BD;
                  }
              }
          .intro{
              padding: 40px 0;
              color:#010101;
              font-size: 14px;
              font-family: "Microsoft YaHei UI Light";
              line-height: 30px;
          }
              .more{
                  color:#979797;
                  font-size: 14px;
                  font-family: "Microsoft YaHei UI Light";
                padding-bottom: 30px;
                  transition: all 1s;
                  cursor: pointer;
                  i{
                      padding-left: 10px;
                  }
              }
              .more:hover{
                  color:#0068B7;
              }
              .allItem{
                  width:100%;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  margin-top: 60px;
                  .item{
                      text-align: center;
                      cursor: pointer;
                      .i{
                          height:60px;
                          img{
                              transition: all 1s;
                          }
                      }
                      p{
                          font-family: "Microsoft YaHei";
                          font-weight: bolder;
                          color:#0068B7;
                          font-size: 20px;
                      }
                  }
                  .item:hover{
                      .i{
                          img{
                              transform: rotateY(180deg);
                          }
                      }
                  }
              }
          }
      }
      .nList{
          width:1440px;
          margin: 60px auto;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .item{
              width:32%;
              cursor: pointer;
              overflow: hidden;
              img{
                  width:100%;
                  object-fit: cover;
                  transition: all 1s;
              }
              .name{
                  padding: 20px 0;
                  color:#383838;
                  font-size: 23px;
                  font-family: "Microsoft YaHei";
                  font-weight: bolder;
                  transition: all 1s;
              }
              .zy{
                  color:#979797;
                  font-size: 14px;
                  line-height: 30px;
                  height:60px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  transition: all 1s;
                  font-family: "Microsoft YaHei UI Light";
              }
              .more{
                  color:#979797;
                  font-size: 14px;
                  font-family: "Microsoft YaHei UI Light";
                  padding-top: 20px;
                  transition: all 1s;
                  i{
                      padding-left: 10px;
                  }
              }
          }
          .item:hover{
              img{
                  transform: scale(1.05);
              }
              .zy{
                  color:black;
              }
              .more{
                  color:#005FAC;
              }
          }
      }
  }
    @media screen and (max-width: 1440px) and (min-width: 1000px){
    .main{
        .one{
            .title{
                width:90%;
            }
        }
        .yList,.about,.nList{
            width:90%;
        }
        .info{
            .bigImg{
                height:500px;
            }
        }
        .yList{
            .item{
                .name{
                    font-size: 18px;
                }
            }
        }
    }
    }
    @media screen and (max-width: 999px){
        .main{
            .one{
                width:95%;
                margin-left: 2.5%;
                .title{
                    width:95%;
                    flex-direction: column;
                    display: flex;
                    span{
                        padding-left: 0;
                        margin-top: 10px;
                    }
                }
            }
            .yList{
                width:95%;
                flex-direction: column;
                margin-top: 0;
                .item{
                    width:100%;
                    margin-top: 60px;
                    .name{
                        padding: 10px 0;
                        font-size: 20px;
                    }
                    .more{
                        padding-top: 10px;
                    }
                }
            }
            .info{
                .bigImg{
                    height:650px;
                }
                .textInfo{
                    top:60px;
                    p:nth-child(1){
                        font-size: 20px;
                    }
                    p:nth-child(2){
                        line-height: 30px;
                    }
                    .items{
                        flex-wrap: wrap;
                        .item{
                            width:50%;
                            padding: 0;
                        }
                    }
                }
                .btn{
                    right:33%;
                    bottom:8%;
                }
            }
            .about{
                width:95%;
                flex-direction: column;
                padding-bottom: 0;
                .left{
                    width:100%;
                    height:250px;
                    img{
                        height:100%;
                    }
                    .line{
                        display: none;
                    }
                }
                .right{
                    margin-left: 0;
                    width:100%;
                    margin-top: 30px;
                    .intro{
                        padding: 20px 0;
                    }
                    .allItem{
                        margin-top: 0;
                        flex-direction: column;
                        .item{
                            margin-top: 30px;
                        }
                    }
                }
            }
            .nList{
                width:95%;
                flex-direction: column;
                margin: 30px auto;
                .item{
                    width:100%;
                    margin-top: 40px;
                    .name{
                        font-size: 18px;
                    }
                }
            }
        }
    }
}
</style>
